<template>
  <div class="mloginApp" :style="'background:url('+backgroundImage+') no-repeat center 0;height:'+curHeight+'px'">
    <div class="loginCon">
      <h2>专家评审授权登录</h2>
      <p>
        <input type="text" v-model="username" placeholder="用户名/账号/手机号" />
        <img src="~assets/images/login_user.png" />
      </p>
      <p>
        <input type="password" v-model="password" placeholder="请输入您的密码" />
        <img src="~assets/images/login_pwd.png" />
      </p>
      <p>
        <a @click="login">登录</a>
      </p>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        backgroundImage: require('../../../assets/images/loginApp.png'),
        curHeight:0,
        password:'',
        username:''
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      login:function(){
        let that = this;
        if(that.username == ''){
          that.$alert('请输入账号', '提示');
          return false;
        }
        if(that.password == ''){
          that.$alert('请输入密码', '提示');
          return false;
        }
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/login',
          data:{
            "phone": that.username,
            "password": that.password
          },
          dataType:'json',
          success:function(data){
            if(data.status == 200){
            that.fullscreenLoading = false;
              that.$router.push('checkny');
              localStorage.setItem('qkan', data.data);
            }else{
              that.$alert(data.message, '提示');
            }
            that.fullscreenLoading = false;
          }
        })
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:80%
  }
  .mloginApp{
    display:block;
    max-width:750px;
    margin:0 auto;
    height:100%;
    background-size:100% 100% !important;
    position: relative;
  }
  .mloginApp .loginCon{
    width:90%;
    position: absolute;
    border-radius: 16px;
    background:#fff;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
    background-size:100% !important;
    padding-bottom:30px
  }
  .mloginApp .loginCon h2{
    font-size: 28px;
    font-family: shetumodengxiaofangti;
    font-weight: 500;
    color: #2D63FF;
    -webkit-text-stroke: 1px #2D63FF;
    text-stroke: 1px #2D63FF;
    text-align:center;
    padding:43px 0
  }
  .mloginApp .loginCon p{
    width: 92%;
    height: 54px;
    margin:0 auto 20px auto;
    position: relative;
  }
  .mloginApp .loginCon p input{
    width:82%;
    height: 54px;
    background: #F8F8F8;
    border-radius: 32px;
    border:none;
    outline:none;
    font-size:16px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color:#000;
    padding:0 3px 0 15%
  }
  .mloginApp .loginCon p img{
    position: absolute;
    left:20px;
    top:12px
  }
  .mloginApp .loginCon p a{
    display:block;
    width: 100;
    height: 54px;
    background: linear-gradient(0deg, #3D6FFF, #2D63FF);
    border-radius: 32px;
    text-align:center;
    line-height: 54px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    color: #FFFFFF;
    cursor: pointer;
  }
  .mloginApp .loginCon p input::-webkit-input-placeholder { color: #C5C5C5 !important; } 
  .mloginApp .loginCon p input::-moz-input-placeholder { color: #C5C5C5 !important;} 
  .mloginApp .loginCon p input::-ms-input-placeholder { color: #C5C5C5 !important;}
</style>